// Store unit preference
function setUnitPreference(unit) {
  if (!['metric', 'imperial'].includes(unit)) return;
  localStorage.setItem('unitPreference', unit);
}

// Get stored unit preference
function getUnitPreference() {
  return localStorage.getItem('unitPreference') || 'metric';
}

// Update UI based on stored unit
function updateUnitDisplay(unit) {
  const metricElements = document.querySelectorAll('.metric-unit');
  const imperialElements = document.querySelectorAll('.imperial-unit');
  const buttons = document.querySelectorAll('.unit-button');
  const calculatorUnitBtns = document.querySelectorAll('.calculator-unit-btn');

  metricElements.forEach((el) => {
    el.style.display = unit === 'metric' ? 'inline' : 'none';
  });

  imperialElements.forEach((el) => {
    el.style.display = unit === 'imperial' ? 'inline' : 'none';
  });

  buttons.forEach((btn) => {
    btn.classList.toggle('active', btn.dataset.unit === unit);
  });

  calculatorUnitBtns.forEach((btn) => {
    btn.classList.toggle('active', btn.dataset.unit === unit);
  });

  // Optional global hook
  document.documentElement.dataset.unit = unit;
}
